export default __webpack_public_path__ + "static/media/wallet-connect-text.c3eccd4c.svg";